import { Component, Input, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements OnInit, OnDestroy {
  currentSlide: number = 0;
  nextSlideIndex: number = 1;
  direction: 'left' | 'right' =  'right';
  animating = false;

  @Input() items: { image: string; title: string }[] = [];
  slideInterval: any;

  ngOnInit(): void {
    this.startAutoSlide();
  }

  ngOnDestroy(): void {
    if (this.slideInterval) {
      clearInterval(this.slideInterval);
    }
  }

  startAutoSlide(): void {
    this.slideInterval = setInterval(() => {
      this.nextSlide();
    }, 3000);
  }

  prevSlide(): void {
    if (this.animating) return;
    this.direction = 'left';
    this.nextSlideIndex = (this.currentSlide - 1 + this.items.length) % this.items.length;
    this.triggerTransition();
  }

  nextSlide(): void {
    if (this.animating) return;
    this.direction = 'right';
    this.nextSlideIndex = (this.currentSlide + 1) % this.items.length;
    this.triggerTransition();
  }

  triggerTransition(): void {
    this.animating = true;
    setTimeout(() => {
      this.currentSlide = this.nextSlideIndex;
      this.animating = false;
    }, 500);
  }
}
